import React from "react";

function ContentBlock({
  children,
  extraClass,
  containerClass = "py-3",
  style,
}) {
  return (
    <div className={`col-12 ${extraClass}`} style={style}>
      <div className={`${containerClass} mb-1 bg-white shadow-sm rounded`}>
        {children}
      </div>
    </div>
  );
}

ContentBlock.defaultProps = {
  extraClass: "",
  style: {},
};

export default ContentBlock;
